import { render } from "./ProfitAndLossReportTable.vue?vue&type=template&id=6101dba0&scoped=true"
import script from "./ProfitAndLossReportTable.vue?vue&type=script&lang=js"
export * from "./ProfitAndLossReportTable.vue?vue&type=script&lang=js"

import "./ProfitAndLossReportTable.vue?vue&type=style&index=0&id=6101dba0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6101dba0"]])

export default __exports__